import React from "react";
import ModalFormLote from "./ModalFormLote";

const ModalLote = ({ show, handleClose, lote }) => {
  return (
    <ModalFormLote show={show} handleClose={handleClose} lote={lote} />
  );
};

export default ModalLote;
